import React, { Suspense, useEffect, useState } from "react";

import { useCurrentRouteProps } from "../../app/router";

import { useAsyncJobDownload } from "../../hooks/useAsyncJobDownload";

import AISummaryPortal from "../Reviews/ViewReviewsAI/portals/AiSummaryPortal";

// load in the goal tree
const LazyViewReviewPage = React.lazy(() => import("./ViewReview"));

const ViewReviewPageLazyLoader = () => {
	const routeProps = useCurrentRouteProps();
	// before rendering the page, we need to set some properties in the config
	// object.
	const [finishedSetup, setFinishedSetup] = useState(false);
	const [aiElementId, setAiElementId] = useState<string>("");
	const [hasForms, setHasForms] = useState<boolean>(false);

	useAsyncJobDownload("review-download-goal-discussion-csv");

	useEffect(() => {
		// this page is a hybrid of react and non-react. We need to make sure
		// that the html is "correct" before we render the react page.
		const element = document.getElementById("view-review-tabs");

		// if the element is found, we can assume the html is "correct"
		if (element) {
			setFinishedSetup(true);
		} else {
			window.location.reload();
		}
	}, [routeProps.pageName]);

	// Setup for the AI Review Portal
	useEffect(() => {
		const aiContainer = document.getElementById("ai-review-summary");
		if (aiContainer) {
			const reviewId = aiContainer.getAttribute("data-review-id");
			if (reviewId) {
				setAiElementId("ai-review-summary");
				const hasForms = aiContainer.getAttribute("data-has-forms");
				setHasForms(hasForms === "True");
			}
		}
	}, []);

	if (!finishedSetup) {
		return null;
	}

	return (
		<Suspense fallback={null}>
			<LazyViewReviewPage hasForms={hasForms} />
			{aiElementId && <AISummaryPortal key={`portal-${aiElementId}`} elementId={aiElementId} />}
		</Suspense>
	);
};
export default ViewReviewPageLazyLoader;
